<template>
	<v-modal class="v-modal--welcome-form v-modal--expanded">
		<template v-slot:header>
			<h1 class="alpha">Confirm Purchase Property {{ $present("ntext", "Address", "Addresses", instructions.length) }}</h1>
		</template>
		<form v-if="formReady" @submit.prevent>
			<v-tabs
				ref="tabs"
				:tabless="true"
				:updateHash="false"
				class="tabs--bullets">
				<v-tab
					v-for="(instruction, instructionId) in instructions"
					:id="'purchase-property-address-' + instructionId"
					:key="instructionId"
					:tab-key="instructionId" label="Purchase Property Address">
					<fieldset class="section">
						<div>
							<!--							<div>-->
							<!--								<legend><span class="alpha highlight-text">Search Pack Details</span></legend>-->
							<!--							</div>-->
							<div>
								<AddressLookup
									v-model="form.data.search_packs[instructionId].address"
									:errors="form.errors"
									:prefill="form.getData('search_packs.' + instructionId + '.address')"
									fieldId="address"
									header="Purchase Property Address"
									header-class="alpha highlight-text"/>
								<label
									class="checkbox alert alert--warning"><span>Please confirm your purchase property address is accurate </span>
									<input
										v-model="form.data.search_packs[instructionId].address.details_confirmed"
										type="checkbox">
									<div class="help-block">
										<p>Before confirming your purchase property address, please ensure it is correct as an incorrect purchase property address may result in an additional search pack having to be carried out for which you will be charged an additional fee.</p>
									</div>
								</label>
							</div>
						</div>
					</fieldset>
				</v-tab>
			</v-tabs>
		</form>
		<template v-slot:footer>
			<ul v-if="refs.tabs" class="actions actions--right">
				<li>
					<button
						class="button button--text"
						@click.prevent="$vmodal.close()">Close
					</button>
				</li>
				<li>
					<process-button
						:processing="form.processing"
						:text="!refs.tabs.next ? 'Save' : 'Save And Continue'"
						class="button button--primary"
						@click.prevent="save()"/>
				</li>
			</ul>
		</template>
	</v-modal>
</template>
<script>
import AddressLookup from "../../../components/forms/fields/AddressLookup";
import essentialTasks from "../mixins/essentialTasks";

export default {
	components: {
		AddressLookup,
	},

	mixins: [
		essentialTasks,
	],

	data() {
		return {
			formReady: false,
			form: this.newForm({
				search_packs: [{
					address: {
						address_identifier: "",
						address_street: "",
						address_locality: "",
						address_province: "",
						address_postcode: "",
						details_confirmed: false,
					},
				}],
			}),
		};
	},

	computed: {
		instructions() {
			let task = _.find(this.$store.getters.essentialTasks(), task => {
				return task.key === "confirmPurchasePropertyAddress";
			});
			return _.pickBy(this.clientGroup.interactiveInstructions, instruction => {
				return task.data?.instructions?.indexOf(instruction.id) > -1;
			});
		},
	},

	methods: {
		save() {
			this.form.patch(this.route("welcome")).then(response => {
				this.$store.commit("authStore/SET_AUTHED", response.data);

				this.shakeTask();

				if (!this.refs.tabs.next) {
					this.$vmodal.close(() => {
						this.showNextTaskModal("confirmPurchasePropertyAddress");
					});
				}

				this.refs.tabs.goToNext();
			});
		},
	},

	created() {
		let searchPacks = {};

		_.each(this.instructions, (instruction, id) => {
			searchPacks[id] = instruction.searchPack;
		});
		this.form.prefill({
			search_packs: searchPacks,
		});
		this.formReady = true;
	},
};
</script>
